import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as v from '../../../helpers/validation';
// SERVICES
import { getUserById, putAdminUser } from '../../../services';
import { DynamicForm } from '../../DynamicForm';

const styles = theme => ({
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  existingLogo: {
    height: '100%',
    maxHeight: 150,
  },
});

export const AdminUsersDetail = withStyles(styles)(props => {
  const { match } = props;
  const { userId } = match.params;

  const [adminInfoFormData, setAdminInfoFormData] = useState(null);
  const adminUserInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'text',
              field: 'userName',
              label: 'Username',
              disabled: true,
              validate: [v.required()],
            },
            {
              inputType: 'text',
              field: 'email',
              label: 'Email',
              validate: [v.required()],
            },
          ],
        },
      ],
    },
  ];

  useEffect(() => {
    const getAdminUserAsync = async () => {
      let adminUserObj = await getUserById(userId);
      setAdminInfoFormData(adminUserObj);
    };

    getAdminUserAsync();
  }, []);

  return (
    <div className={classnames('grid-container')}>
      <DynamicForm mode={'EDIT'} inputs={adminUserInputs} data={adminInfoFormData} onSave={putAdminUser} />
    </div>
  );
});
